import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { DialogType, Dialog, NeutralColors } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
const dialogContentStyles = {
    header: {
        color: NeutralColors.gray160,
        fontWeight: '600'
    },
    subText: {
        color: NeutralColors.gray130,
        whiteSpace: 'pre-line'
    },
    content: {
        margin: '16px'
    }
};
const modalMinWidth = '620px';
const modalProps = {
    isDarkOverlay: true
};
export const AzureRedirectModal = ({ linkClicked, onDismiss }, context)=>{
    const [OpenDialog, { toggle: toggleOpenDialog }] = useBoolean(true);
    const [RedireactDialog, { toggle: toggleRedirectDialog }] = useBoolean(true);
    useEffect(()=>{
        if (linkClicked) {
            toggleOpenDialog();
            setTimeout(()=>{
                toggleOpenDialog();
                toggleRedirectDialog();
            }, 2000);
        }
    }, [
        linkClicked
    ]);
    const redirectModalContentProps = (context)=>{
        return {
            type: DialogType.close,
            title: context.loc('RedirectModal_Title', 'All done. You can close this tab now'),
            closeButtonAriaLabel: context.loc('Dialog_Close', 'Close'),
            subText: context.loc('RedirectModal_SubHeader_Text', 'We opened the offer in the Azure portal.'),
            styles: dialogContentStyles
        };
    };
    const openTabModalContentProps = (context)=>{
        return {
            type: DialogType.normal,
            title: context.loc('OpenModal_Title', 'Opening Azure in a new tab to complete the purchase ...'),
            closeButtonAriaLabel: context.loc('Dialog_Close', 'Close'),
            styles: dialogContentStyles
        };
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Dialog, {
                hidden: OpenDialog,
                dialogContentProps: openTabModalContentProps(context),
                minWidth: modalMinWidth,
                modalProps: modalProps
            }),
            /*#__PURE__*/ _jsx(Dialog, {
                hidden: RedireactDialog,
                dialogContentProps: redirectModalContentProps(context),
                minWidth: modalMinWidth,
                onDismiss: ()=>{
                    toggleRedirectDialog();
                    onDismiss();
                },
                modalProps: modalProps
            })
        ]
    });
};
AzureRedirectModal.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
